import { HeartOutlined, SmileOutlined, UserOutlined } from '@ant-design/icons';
import { Card, Flex } from 'antd';
import React from 'react';
import styled from 'styled-components';
import AttributeInfo from './AttributeInfo';
import type { LeaderboardRow } from './hooks/useLeaderboard';

type LeaderboardNode = Extract<LeaderboardRow, { node: unknown }>['node'];

interface ExpandableRowProps {
  node: LeaderboardNode;
}

const StyledCard = styled(Card)`
  background-color: rgb(227 229 230 / 50%);
  border: 0;
  box-shadow: 0 1px 2px rgb(0 0 0 / 10%);

  .ant-card-body {
    padding: 16px;
  }
`;

const ExpandableRow = function ({ node }: ExpandableRowProps) {
  const {
    scores: { style, profile, happiness },
  } = node;

  return (
    <StyledCard>
      <Flex justify="space-around" gap={12}>
        {style !== null && (
          <AttributeInfo icon={HeartOutlined} title="Style" extra={style} />
        )}
        <AttributeInfo icon={UserOutlined} title="Profile" extra={profile} />
        <AttributeInfo
          icon={SmileOutlined}
          title="Happiness"
          extra={happiness}
        />
      </Flex>
    </StyledCard>
  );
};

export default ExpandableRow;
